var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents_zero",
    "data-name": "documents zero",
    transform: "translate(-134.472 -131.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages_image",
    "data-name": "messages image",
    transform: "translate(24.644 60.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.003 -16.446)",
    fill: "#a4a9b0",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.003 -1.447)",
    fill: "#a4a9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mail-inbox-app_3_",
    "data-name": "mail-inbox-app (3)",
    d: "M25.274,80.048H7.737A7.746,7.746,0,0,1,0,72.311V61.737A7.746,7.746,0,0,1,7.737,54H25.274a7.746,7.746,0,0,1,7.737,7.737V72.311A7.746,7.746,0,0,1,25.274,80.048ZM7.737,56.579a5.164,5.164,0,0,0-5.158,5.158V72.311a5.164,5.164,0,0,0,5.158,5.158H25.274a5.164,5.164,0,0,0,5.158-5.158V61.737a5.164,5.164,0,0,0-5.158-5.158ZM21.231,69.307,27.6,64.438a1.289,1.289,0,0,0-1.566-2.049l-6.373,4.868a5.171,5.171,0,0,1-6.252,0l-6.176-4.8A1.29,1.29,0,1,0,5.656,64.5l6.18,4.8.009.007a7.756,7.756,0,0,0,9.385,0Z",
    transform: "translate(18.493 -33.471)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6c7111a1b8f24deee5bdbaa37ae1989e.svg";
export { ForwardRef as ReactComponent };